export const paymentOptionsMix = {
  data() {
    return {
      showCouponForm: false,
      previouslyTriedCouponCode: '',
      couponCode: '',
      selectedPaymentOptionId: null, // non-recurring
      pendingPlan: null,
      registrations: [],
      checkouts: [],
      invoices: [],
      donationAmount: null,
      registrationIsClosed: false,
    };
  },
  computed: {
    cashSelected() {
      return this.paymentMethod === 'cash';
    },
    creditSelected() {
      return !this.cashSelected;
    },
    donationAdded() {
      return this.donationAmount != null;
    },
    validCouponApplied() {
      const vm = this;
      if (vm.invoices.length === 0) {
        return false;
      }

      const invoiceItems = _.flatMap(vm.invoices, 'invoice_items');
      const couponItems = _.filter(invoiceItems, [
        'transactable.code',
        vm.couponCode,
      ]);
      return couponItems.length > 0;
    },
    free() {
      const vm = this;

      if (!vm.pendingPlan) {
        return false;
      }

      let total = 0;

      vm.invoices.forEach((mi) => {
        total += mi.amount_due;
      });

      return total === 0;
    },
    installmentsPicked() {
      const vm = this;
      if (!vm.selectedPaymentOption) {
        return false;
      }

      return vm.selectedPaymentOption.payment_strategy === 'installments';
    },
    activePaymentOptions() {
      return _.filter(this.session.payment_options, ['status', 'active']);
    },
    selectedPaymentOption() {
      if (this.selectedPaymentOptionId) {
        return _.find(this.activePaymentOptions, [
          'id',
          this.selectedPaymentOptionId,
        ]);
      }

      return null;
    },
  },
  methods: {
    allowsCash() {
      const vm = this;
      return (
        vm.selectedPaymentOption
        && vm.selectedPaymentOption.allowed_payment_methods === 'all'
      );
    },
    cashTapped() {
      this.paymentMethod = 'cash';
    },
    creditTapped() {
      this.paymentMethod = 'card';
    },
    toggleShowCoupon() {
      this.showCouponForm = !this.showCouponForm;
    },
    removeCoupon() {
      this.previouslyTriedCouponCode = '';
      this.couponCode = '';
      this.showCouponForm = true;
      this.previewCharge(this.previewUrl);
    },
    selectOption(option) {
      const vm = this;
      vm.selectedPaymentOptionId = option.id;
      if (vm.selectedPaymentOption) {
        vm.previewCharge(this.previewUrl);
      }
    },
    optionDescription(option) {
      if (option.deposit_amount && option.deposit_amount > 0) {
        const deposit = (option.deposit_amount / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        });
        const balance = (option.price / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        });
        if (option.payment_strategy === 'installments') {
          return `<p>${deposit} commitment deposit due now. Remaining balance charged in installments after roster approval.</p>`;
        }
        return `<p>${deposit} commitment deposit due now. Remaining ${balance} charged after roster approval.</p>`;
      }

      if (option.payment_strategy === 'once') {
        return '<p>One time charge, due now.</p>';
      }

      if (option.allowed_payment_methods === 'card') {
        return '<p>Payment will be automatically charged to your card on the following dates.</p>';
      }

      return '<p>This is an installment based option, payment is due on the following dates:</p>';
    },
    futureInstallmentListFor(option) {
      const installmentList = _.map(
        option.installment_plan.installments,
        (i) => {
          const chargeDate = moment(i.date);
          if (this.isDateSameOrBeforeToday(chargeDate)) {
            return '';
          }

          const price = (i.price / 100.0).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          });
          return `<div>Due ${chargeDate.format('M/D/YYYY')}: ${price}</div>`;
        },
      );

      return _.join(installmentList, '');
    },
    dueNowFor(option) {
      if (option.payment_strategy !== 'installments') {
        return 0;
      }

      const installmentTotalNow = _.sum(
        _.map(option.installment_plan.installments, (i) => {
          const chargeDate = moment(i.date);
          if (this.isDateSameOrBeforeToday(chargeDate)) {
            return i.price;
          }

          return 0;
        }),
      );

      let totalNow = installmentTotalNow;
      if (option.deposit_amount && option.deposit_amount > 0) {
        totalNow += option.deposit_amount;
      }

      return (totalNow / 100.0).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      });
    },
    dueNowDisplay(option) {
      // Team registration: only the deposit is charged now
      if (
        this.isTeamRegistration
        && option.deposit_amount
        && option.deposit_amount > 0
      ) {
        return this.formatAsCurrency(option.deposit_amount);
      }
      if (option.payment_strategy === 'installments') {
        return this.dueNowFor(option);
      }
      return this.formatAsCurrency(option.price);
    },
    afterApprovalTotal(option) {
      return this.formatAsCurrency(option.price);
    },
    installmentListForTeamReg(option) {
      const installmentList = _.map(
        option.installment_plan.installments,
        (i) => {
          const chargeDate = moment(i.date);
          const price = (i.price / 100.0).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          });
          if (this.isDateSameOrBeforeToday(chargeDate)) {
            return `<div>After approval: ${price}</div>`;
          }
          return `<div>After approval, on ${chargeDate.format(
            'M/D/YYYY',
          )}: ${price}</div>`;
        },
      );

      return _.join(installmentList, '');
    },
    isDateSameOrBeforeToday(date) {
      const today = moment();
      return date.isSameOrBefore(today);
    },
    teamRegDue(invoice) {
      const chargeDate = moment(invoice.due_on);
      if (this.isDateSameOrBeforeToday(chargeDate)) {
        return this.selectedDepositAmount > 0 ? 'Deposit' : 'Charged after approval';
      }

      if (this.installmentsPicked) {
        return `After approval, on ${chargeDate.format('M/D/YYYY')}`;
      }

      return 'After approval';
    },
    due(invoice) {
      const chargeDate = moment(invoice.due_on);
      if (this.isDateSameOrBeforeToday(chargeDate)) {
        return 'Due now';
      }

      return `Charged ${chargeDate.format('M/D/YYYY')}`;
    },
    installmentPaymentDueNow() {
      const vm = this;

      if (!vm.installmentsPicked || !vm.pendingPlan) {
        return false;
      }

      // Now we are in install land
      let dueNow = false;
      vm.pendingPlan.manual_invoices.forEach((mi) => {
        const dueDate = moment(mi.due_on);
        const isTodayOrPast = vm.isDateSameOrBeforeToday(dueDate);
        if (isTodayOrPast) {
          dueNow = true;
        }
      });

      return dueNow;
    },
    installmentTotalDueNow(plusInsuranceTotal) {
      const vm = this;

      if (!vm.pendingPlan) {
        return '--';
      }

      let total = 0;

      vm.pendingPlan.manual_invoices.forEach((mi) => {
        const dueDate = moment(mi.due_on);
        const isTodayOrPast = vm.isDateSameOrBeforeToday(dueDate);
        if (isTodayOrPast) {
          total += mi.amount_due;
        }
      });

      return vm.formatAsCurrency(total + plusInsuranceTotal);
    },
    total(plusInsuranceTotal) {
      const vm = this;

      if (!vm.pendingPlan) {
        return '--';
      }

      let total = 0;

      vm.pendingPlan.manual_invoices.forEach((mi) => {
        total += mi.amount_due;
      });

      return vm.formatAsCurrency(total + plusInsuranceTotal);
    },
    attemptCoupon() {
      this.previewCharge(this.previewUrl);
    },
    previewCharge(url) {
      const vm = this;
      vm.loadingPreview = true;

      // Make sure we note what the coupon was for the actual request at the time.
      const previousCoupon = vm.couponCode;

      const params = {
        payment_plan: {
          registrations: vm.buildRegistrationPayload(),
          coupon: vm.couponCode,
          donation_amount: this.donationAmount || 0,
          payment_method_type: this.paymentMethod,
          billing_plans_added: vm.buildProductPayload
            ? vm.buildProductPayload()
            : [],
        },
      };

      axios
        .post(url, params)
        .then((response) => {
          if (response.data.checkouts) {
            // V2: store raw checkouts, flatten for existing computeds
            vm.checkouts = response.data.checkouts;
            vm.pendingPlan = {
              manual_invoices: _.flatMap(
                response.data.checkouts,
                'manual_invoices',
              ),
              registrations: _.flatMap(
                response.data.checkouts,
                'registrations',
              ),
            };
          } else {
            vm.checkouts = [];
            vm.pendingPlan = response.data;
          }
          vm.registrations = vm.pendingPlan.registrations;
          vm.invoices = vm.pendingPlan.manual_invoices;
          vm.previouslyTriedCouponCode = previousCoupon;
          vm.$forceNextTick(() => {
            vm.loadingPreview = false;
          });
        })
        .catch((error) => {
          if (error.response?.status === 422) {
            const errorMessages = error.response.data?.errors || [];
            if (
              Array.isArray(errorMessages)
              && errorMessages.some(
                (msg) => msg && msg.includes('Registration is closed'),
              )
            ) {
              vm.registrationIsClosed = true;
              vm.errorMessage = 'Registration is closed';
            } else {
              vm.errorMessage = `Error retrieving price ${error.toString()}`;
            }
          } else {
            vm.errorMessage = `Error retrieving price ${error.toString()}`;
          }
          vm.error = true;
          vm.loadingPreview = false;
        });
    },
  },
};
